import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import queryString from 'querystring'
import { isEmpty } from 'lodash'
import cn from 'classnames'
import { css, StyleSheet } from 'aphrodite'
import Layout from '../components/Layout'
import { useLoad, useDeleteRequest } from '../hooks/request'
import { useModal } from '../hooks/modal'
import { useMessage } from '../hooks/message'
import { USER_LIST, USER_DETAIL } from '../urls'
import Table from '../components/common/Table'
import Button from '../components/common/Button'
import Search from '../components/Search'
import UserCreate from '../components/UserCreate'
import UserUpdate from '../components/UserUpdate'
import empty from '../static/empty-shop.png'
import { useQueryParams } from '../hooks/queryString'

export default function Users() {
    const params = useQueryParams()
    const history = useHistory()
    const [page, setPage] = useState(1)
    const [showMessage] = useMessage()

    const users = useLoad({
        url: USER_LIST,
        params: { page, ...params }
    }, [params, page])

    const userList = users.response ? users.response.results : []

    const [showCreateModal, setShowCreateModal] = useModal(
        <UserCreate reload={users} onCancel={() => setShowCreateModal()} />

    )

    function onSearch(query) {
        const search = !isEmpty(query) ? query : undefined
        history.push(`?${queryString.stringify({ ...params, search })}`)
    }

    return (
        <Layout>
            <div className="is-flex mb-3">
                <Search onSearch={onSearch} />
                <Button
                    text="Добавить пользователя"
                    className="button is-link is-outlined ml-2"
                    onClick={showCreateModal}
                />
            </div>

            <div className="mt-4">
                {users.response && users.response.count === 0 ? (
                    <div className="is-flex is-justify-content-center is-align-items-center hei">
                        <img
                            alt="empty"
                            src={empty}
                            className={cn(css(styles.emptyImg), 'is-horizontal-center')}
                        />
                    </div>
                ) : (
                    <Table
                        loading={users.loading}
                        items={userList}
                        columns={{
                            index: '№',
                            name: 'Имя',
                            email: 'Email',
                            role: 'Роль',
                            is_active: 'Активен',
                            created_at: 'Дата создания',
                            actions: 'Действие'
                        }}
                        totalCount={users.response ? users.response.count : 0}
                        pageSize={15}
                        activePage={page}
                        onPageChange={setPage}
                        renderItem={(item, index) => (
                            <UserItem
                                key={item.id}
                                item={item}
                                index={index}
                                users={users}
                                showMessage={showMessage}
                            />
                        )}
                    />
                )}
            </div>
        </Layout>
    )
}

function UserItem({ item, index, users, showMessage }) {
    const userRemove = useDeleteRequest({ url: USER_DETAIL.replace('{id}', item?.id) })

    const [showUpdateModal, setShowUpdateModal] = useModal(
        <UserUpdate
            users={users}
            item={item}
            hideModal={() => setShowUpdateModal()}
        />
    )

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить этого пользователя?')) {
            const { success, error } = await userRemove.request()
            if (success) {
                await users.request()
                showMessage('Пользователь успешно удален', 'is-success')
            }
            if (error) {
                showMessage('Ошибка при удалении пользователя', 'is-danger')
            }
        }
    }

    return (
        <tr className="is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{item?.firstName} {item?.lastName}</td>
            <td className="is-size-6">{item?.email}</td>
            <td className="is-size-6">
                <span className={`tag ${item?.isStaff ? 'is-danger' : 'is-info'}`}>
                    {item?.isStaff ? 'Администратор' : 'Пользователь'}
                </span>
            </td>
            <td className="is-size-6">
                <span className={`tag ${item?.isActive ? 'is-success' : 'is-light'}`}>
                    {item?.isActive ? 'Активен' : 'Неактивен'}
                </span>
            </td>
            <td className="is-size-6">
                {new Date(item?.createdAt).toLocaleDateString()}
            </td>
            <td style={{ display: 'flex', alignItems: 'center' }}>
                <div className="is-pulled-right">
                    <Button
                        onClick={showUpdateModal}
                        className="mr-2 button is-success is-outlined is-small"
                        icon="pencil-outline"
                    />
                    <Button
                        onClick={onDelete}
                        className="button is-danger is-outlined is-small"
                        icon="trash"
                    />
                </div>
            </td>
        </tr>
    )
}

const styles = StyleSheet.create({
    emptyImg: {
        width: '330px',
        height: '300px'
    }
})
